import { ErrorType } from '../../shared/types';
import { PayWithStoredPayment } from '../contracts';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import StatusCode from 'status-code-enum';
import { ErrorCode, PaymentType } from '@ace-clublabs/payment-types';
import { IPayWithStoredPaymentRequest } from '../../types';
import { createAxiosConfig } from '../mockHelper';
import { LogCannon } from '@ace-clublabs/log-cannon';

export const PayWithStoredPaymentApi =
  (endpoint: string): PayWithStoredPayment =>
  async (request: IPayWithStoredPaymentRequest) => {
    try {
      LogCannon.blast('PayWithStoredPaymentApi start', {
        endpoint,
      });
      const scenario = CookieHelper.getCookie('scenario');
      const { data } = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint, true));
      LogCannon.blast('PayWithStoredPaymentApi success');
      return Promise.resolve(data);
    } catch (error: any) {
      let type = ErrorType.SYSTEM_ERROR;

      if (error.response) {
        const statusCode = error?.response?.status;
        const errorMessage = error?.response.data?.message || error?.message || error?.response?.data?.error?.message;
        LogCannon.error('PayWithStoredPaymentApi error', statusCode);

        if (statusCode === StatusCode.ClientErrorUnauthorized) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.SESSION_TIMEOUT,
          });
        }

        if (statusCode === StatusCode.ClientErrorForbidden) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.AUTH_ERROR,
          });
        }

        if (statusCode === StatusCode.ClientErrorPaymentRequired) {
          const data = error?.response?.data;
          let code;
          if (data?.transactionResults)
            code =
              data?.transactionResults[0].paymentError?.code || data?.transactionResults[0].autoPayError?.code || '';
          const HandledErrorCodes: ErrorCode[] = [
            ErrorCode.InvalidCard,
            ErrorCode.InvalidCVV,
            ErrorCode.InvalidToken,
            ErrorCode.InvalidExpirationDate,
            ErrorCode.InvalidZipCode,
            ErrorCode.InvalidAccountHolderName,
            ErrorCode.InvalidAccountNumber,
            ErrorCode.InvalidRoutingNumber,
            ErrorCode.InvalidBankAccountOrRoutingNumber,
          ];
          LogCannon.error('Payment processing error code', code);
          if (HandledErrorCodes.includes(code)) {
            const { paymentDetails } = data || {};
            const { paymentType } = paymentDetails || {};
            const { last4 } = paymentDetails?.card || paymentDetails?.echeck || {};
            return Promise.reject({
              message: 'Invalid payment method',
              type: ErrorType.INVALID_PAYMENT_METHOD_ERROR,
              data: {
                last4,
                paymentType: paymentType === PaymentType.Echeck ? 'echeck' : 'card',
                id: request?.tokenId,
              },
            });
          } else {
            return Promise.reject({
              message: errorMessage,
              type: ErrorType.PROCESSING_ERROR,
            });
          }
        }
      }

      return Promise.reject({ type });
    }
  };
